module.exports = __webpack_public_path__ + "static/img/maintenance-mode.c4d3480.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/illustrations/maintenance-mode.svg
// module id = OSDF
// module chunks = 1